/* CrispyCards Sticky Desktop Header – Toolbar + Hauptnavigation, ohne TCG-Slider */
(() => {
  'use strict';


  // CartDrawer aus dem Header-Stapelkontext herausnehmen.
  // Die Impulse-Events und der bestehende Cart bleiben unverändert.
  function placeCartDrawerAtBodyLevel() {
    const drawer = document.getElementById('CartDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  // Auch das mobile Navigationsmenü darf nicht im Stapelkontext
  // der Header-Section gefangen bleiben.
  function placeNavDrawerAtBodyLevel() {
    const drawer = document.getElementById('NavDrawer');
    if (drawer && drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }
  }

  function init() {
    placeCartDrawerAtBodyLevel();
    placeNavDrawerAtBodyLevel();
    document.querySelectorAll('.cc-header-desktop').forEach((root) => {
      if (root.dataset.ccStickyReady === 'true') return;
      const main = root.querySelector('.cc-header-main');
      if (!main) return;
      const toolbar = root.querySelector('.toolbar');
      root.dataset.ccStickyReady = 'true';

      const first = toolbar || main;
      const placeholderMain = document.createElement('div');
      placeholderMain.className = 'cc-sticky-placeholder';
      placeholderMain.setAttribute('aria-hidden', 'true');
      main.after(placeholderMain);

      let placeholderToolbar;
      if (toolbar) {
        placeholderToolbar = document.createElement('div');
        placeholderToolbar.className = 'cc-sticky-placeholder';
        placeholderToolbar.setAttribute('aria-hidden', 'true');
        toolbar.after(placeholderToolbar);
      }

      // Der erste Block bleibt als Anker im Dokument, auch wenn der Header fixiert ist.
      const anchor = document.createElement('span');
      anchor.style.cssText = 'display:block;height:0;width:0;pointer-events:none';
      first.before(anchor);

      let frame = null;
      function update() {
        frame = null;
        if (window.innerWidth <= 768) {
          root.classList.remove('cc-top-stuck');
          return;
        }

        const mainHeight = main.getBoundingClientRect().height;
        const toolbarHeight = toolbar ? toolbar.getBoundingClientRect().height : 0;
        placeholderMain.style.height = `${mainHeight}px`;
        if (placeholderToolbar) placeholderToolbar.style.height = `${toolbarHeight}px`;
        root.style.setProperty('--cc-sticky-toolbar-height', `${toolbarHeight}px`);
        // Höhe des ständig sichtbaren Desktop-Headers für PhotoSwipe bereitstellen.
        document.documentElement.style.setProperty('--cc-visible-header-height', `${Math.ceil(toolbarHeight + mainHeight)}px`);

        // Der Anker bleibt in der normalen Dokumentposition.
        const shouldStick = anchor.getBoundingClientRect().top < -1;
        root.classList.toggle('cc-top-stuck', shouldStick);
      }

      function schedule() {
        if (frame !== null) return;
        frame = requestAnimationFrame(update);
      }
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', schedule, { passive: true });
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) {
          window.removeEventListener('scroll', schedule);
          window.removeEventListener('resize', schedule);
        }
      });
      schedule();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else init();
  document.addEventListener('shopify:section:load', init);
})();
